__turbopack_context__.v({
  "softpopup": "SoftPopup-module-sass-module__WQ4mXa__softpopup",
  "softpopup__panel": "SoftPopup-module-sass-module__WQ4mXa__softpopup__panel",
  "softpopup__panel__button": "SoftPopup-module-sass-module__WQ4mXa__softpopup__panel__button",
  "softpopup__panel__divider": "SoftPopup-module-sass-module__WQ4mXa__softpopup__panel__divider",
  "softpopup__panel__divider__line": "SoftPopup-module-sass-module__WQ4mXa__softpopup__panel__divider__line",
});
